import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import { InlineInput } from '../../../helpers/Input';
import FormGroup from '../../../helpers/FormGroup';
import FormSubmitOnBlur from '../../../helpers/FormSubmitOnBlur';
import { toJS } from '../../../../utils/ChangeSpy';
import { LinksTable } from '../LinksTable';

import style from './style.module.css';

/**
 * Top section component.
 *
 * @param props {Object}.
 * @param props.common {Immutable.Map} General information.
 * @param props.onChange {Function} Handle date change.
 * @param {boolean} props.isNoApproval No approval list selected state.
 */
const FormComponent = ({ common, isNoApproval, onChange, onSubmit }) => {
  const ap = common.get('approval');
  const noAp = common.get('noApproval');
  const linksList = toJS(common.get('linksList'));
  const dateReturned = ap.get('dateReturned');
  const dateSent = ap.get('dateSent');
  const numberTargets = isNoApproval ? noAp.get('numberTargets') : ap.get('numberTargets');
  const numberApproved = isNoApproval ? noAp.get('numberApproved') : ap.get('numberApproved');
  const percentApproved = isNoApproval ? noAp.get('percentApproved') : ap.get('percentApproved');
  const numberMailed = isNoApproval ? noAp.get('numberMailed') : ap.get('numberMailed');
  const percentMailed = isNoApproval ? noAp.get('percentMailed') : ap.get('percentMailed');
  const numberCalled = isNoApproval ? noAp.get('numberCalled') : ap.get('numberCalled');
  const percentCalled = isNoApproval ? noAp.get('percentCalled') : ap.get('percentCalled');

  const renderDatesInputs = isNoApproval ? null : (
    <>
      <FormSubmitOnBlur onSubmit={onSubmit} focusOnClick>
        <FormGroup>
          <InlineInput
            defaultValue={null}
            label="Date Created:"
            name="dateSent"
            onChange={onChange}
            placeholder="date sent"
            type="date"
            value={dateSent}
            showLabel
          />
        </FormGroup>
      </FormSubmitOnBlur>
      <FormSubmitOnBlur onSubmit={onSubmit} focusOnClick>
        <FormGroup>
          <InlineInput
            defaultValue={null}
            label="Date Returned:"
            name="dateReturned"
            onChange={onChange}
            placeholder="date returned"
            type="date"
            value={dateReturned}
            showLabel
          />
        </FormGroup>
      </FormSubmitOnBlur>
    </>
  );

  return (
    <div className={style.host}>
      {renderDatesInputs && <div className={style.dates}>{renderDatesInputs}</div>}
      {toJS(dateSent) && (
        <div className={style.links}>
          <LinksTable linksList={linksList} />
        </div>
      )}
      <div className={style.stats}>
        <div>
          Number of Targets: <strong>{numberTargets}</strong>
        </div>
        <div>
          Number mailed: <strong>{numberMailed}</strong>
        </div>
        <div>
          Number Called: <strong>{numberCalled}</strong>
        </div>
        <div>
          Number Approved: <strong>{numberApproved}</strong>
        </div>
        <div>
          % of app. Mailed: <strong>{percentMailed}</strong>
        </div>
        <div>
          % of app. Called: <strong>{percentCalled}</strong>
        </div>
        <div>
          % Approved: <strong>{percentApproved}</strong>
        </div>
      </div>
    </div>
  );
};

FormComponent.propTypes = {
  common: PropTypes.instanceOf(Map).isRequired,
  isNoApproval: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

/** Form component. */
export const Form = memo(FormComponent);
